// Do NOT add "use client" to this file
import React from "react";

import { ProductTileImageBase } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/__internal__/ProductTileImageBase";
import { ProductTileImageProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductImage/ProductTileImageProps";
import { PRODUCT_GRID_IMAGE_BREAKPOINTS } from "@faire/retailer/views/search/const";

export const ProductImage = ({ data }: { data: ProductTileImageProps }) => {
  const {
    image,
    imageAltText,
    shouldUseLazyImageLoading,
    showVerticalImagery,
    onLoad,
  } = data;

  return (
    <ProductTileImageBase
      image={image}
      imageAltText={imageAltText}
      showVerticalImagery={showVerticalImagery}
      useLazyImageLoading={shouldUseLazyImageLoading}
      imageBreakpoints={PRODUCT_GRID_IMAGE_BREAKPOINTS}
      onLoad={onLoad}
    />
  );
};
